export const API_BASE = 'https://api.mobilink.tech';

export const getToken = () => {
    return (
        sessionStorage.getItem('adminToken') ||
        sessionStorage.getItem('subAdminToken') ||
        ''
    );
};

export const getHeaders = () => {
    const token = getToken();

    return {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
    };
};